jQuery(document).ready(function ($) {
    var buttons = $('.load-more-button');
    var loadingSpinner = "<div class=\"spinner\">\n"
        + "<div class=\"bounce1\"></div>\n"
        + "<div class=\"bounce2\"></div>\n"
        + "<div class=\"bounce3\"></div>\n"
        + "</div>";

        var ajaxCall = function () {
            var $this = $(this);
            var search = "";
            var postContainerClass = $this.data('container-class');
            var postContainer = $('.' + postContainerClass + ' .band-content');
            var displayedPosts = $('.' + postContainerClass + " div[class*='news-preview-']").length;

            if ($this.data('search')) {
                search = $this.data('search');
                postContainer = $('.band-container.' + postContainerClass);
                displayedPosts = $('.band-container.' + postContainerClass + " div.result-preview").length;
            }

            $.ajax({
                url: ajax_object.ajaxurl,
                type: 'post',
                data: {
                    action: 'ajax_load_more',
                    page: $this.data("page"),
                    postsPerPage: $this.data("posts-per-page"),
                    postType: $this.data("post-type"),
                    nonce: $this.data("nonce"),
                    displayedPosts: displayedPosts,
                    containerClass: postContainerClass,
                    totalNews: $this.data("total-news"),
                    postId: $this.data('post-id'),
                    category: $this.data('category'),
                    topic: $this.data('topic'),
                    search: $this.data('search')
                },
                beforeSend: function () {
                    if (search !== "") {
                        $this.fadeTo(200, 0);
                        $this.remove();
                        $(loadingSpinner).appendTo(postContainer).fadeIn(500);
                    }
                },
                success: function (html) {
                    $(html).hide().appendTo(postContainer).fadeIn(500);
                    picturefill();

                    if (search !== "") {
                        $('.spinner').remove();
                    } else {
                        $this.fadeTo(200, 0);
                        $this.remove();
                    }

                    buttons = $('.' + postContainerClass + ' .load-more-button');
                    buttons.each(function () {
                        $(this).click(ajaxCall);
                    });

                    displayedPosts = $('.' + postContainerClass + " div[class*='news-preview-']").length;
                    if (search !== "") {
                        displayedPosts = $('.band-container.' + postContainerClass + " div.result-preview").length;
                    }
                }
            })
        };

    buttons.each(function () {
        $(this).click(ajaxCall);
    });
    }
);